// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Paper,
//   Grid,
//   Snackbar,
//   Alert,
//   CircularProgress,
// } from '@mui/material';
// import { styled } from '@mui/material/styles';
// import { useNavigate } from 'react-router-dom';
// import OtpImage from '../landpageimage/logo1.png'; // Replace with your image path

// const themeColors = {
//   primary: '#2196F3', // Blue
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// const StyledPaper = styled(Paper)(() => ({
//   display: 'flex',
//   width: '90%',
//   maxWidth: '900px',
//   margin: '0 auto',
//   borderRadius: '24px',
//   padding: '16px',
//   overflow: 'hidden',
//   boxShadow: '0 20px 40px rgba(0, 77, 167, 0.15)',
// }));

// const StyledImageBox = styled(Box)(() => ({
//   flex: 1,
//   backgroundImage: `url(${OtpImage})`,
//   backgroundSize: 'cover',
//   backgroundPosition: 'center',
//   borderRadius: '24px 0 0 24px',
//   '@media (max-width: 600px)': {
//     display: 'none',
//   },
// }));

// const StyledFormBox = styled(Box)(() => ({
//   flex: 1,
//   display: 'flex',
//   flexDirection: 'column',
//   alignItems: 'center',
//   justifyContent: 'center',
//   padding: '32px',
// }));

// const StyledOtpField = styled(TextField)(() => ({
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '8px',
//     width: '60px',
//     margin: '0 8px',
//     textAlign: 'center',
//   },
//   '& .MuiInputBase-input': {
//     textAlign: 'center',
//     fontSize: '1.5rem',
//     padding: '8px',
//   },
// }));

// const VerifyButton = styled(Button)(() => ({
//   background: themeColors.gradient,
//   color: 'white',
//   padding: '8px 16px',
//   borderRadius: '16px',
//   fontWeight: 600,
//   marginTop: '16px',
//   '&:hover': {
//     background: '#1E88E5',
//   },
// }));

// export default function Otpverification() {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       // Move focus to the next input
//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (otp.some((digit) => digit === '')) {
//       setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP', severity: 'error' });
//       return;
//     }
//     setLoading(true);

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/verify_otp/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otp: otp.join('') }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'OTP verified successfully!', severity: 'success' });
//         setTimeout(() => navigate('/dashboard'), 2000); // Redirect to dashboard
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Invalid OTP. Please try again.', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <StyledImageBox />
//         <StyledFormBox>
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             mb={3}
//             sx={{
//               color: 'transparent',
//               backgroundImage: themeColors.gradient,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               textAlign: 'center',
//               fontSize: '1.5rem',
//             }}
//           >
//             Verify OTP
//           </Typography>
//           <Typography mb={2} color="text.secondary">
//             Enter the 4-digit OTP sent to your registered email or phone number.
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Box display="flex" justifyContent="center">
//               {otp.map((digit, index) => (
//                 <StyledOtpField
//                   key={index}
//                   id={`otp-input-${index}`}
//                   type="text"
//                   value={digit}
//                   inputProps={{
//                     maxLength: 1,
//                   }}
//                   onChange={(e) => handleChange(e.target, index)}
//                 />
//               ))}
//             </Box>
//             <VerifyButton type="submit" disabled={loading}>
//               {loading ? <CircularProgress size={24} /> : 'Verify OTP'}
//             </VerifyButton>
//           </form>
//         </StyledFormBox>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }



// export function OtpVerification() {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (otp.some((digit) => digit === '')) {
//       setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP', severity: 'error' });
//       return;
//     }
//     setLoading(true);

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/verify_otp/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otp: otp.join('') }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'OTP verified successfully!', severity: 'success' });
//         setTimeout(() => navigate('/dashboard'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Invalid OTP. Please try again.', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <StyledPaper>
//         <Box
//           flex={1}
//           sx={{
//             backgroundImage: `url(${OtpImage})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             borderRadius: '24px 0 0 24px',
//             '@media (max-width: 600px)': {
//               display: 'none',
//             },
//           }}
//         />
//         <Box
//           flex={1}
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           padding="32px"
//         >
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             mb={3}
//             sx={{
//               color: 'transparent',
//               backgroundImage: themeColors.gradient,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               textAlign: 'center',
//               fontSize: '1.5rem',
//             }}
//           >
//             Verify OTP
//           </Typography>
//           <Typography mb={2} color="text.secondary">
//             Enter the 4-digit OTP sent to your registered email.
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Box display="flex" justifyContent="center">
//               {otp.map((digit, index) => (
//                 <TextField
//                   key={index}
//                   id={`otp-input-${index}`}
//                   type="text"
//                   value={digit}
//                   inputProps={{ maxLength: 1 }}
//                   onChange={(e) => handleChange(e.target, index)}
//                   sx={{
//                     width: '60px',
//                     margin: '0 8px',
//                     textAlign: 'center',
//                     fontSize: '1.5rem',
//                     borderRadius: '8px',
//                   }}
//                 />
//               ))}
//             </Box>
//             <Button
//               type="submit"
//               sx={{
//                 background: themeColors.gradient,
//                 color: 'white',
//                 padding: '8px 16px',
//                 borderRadius: '16px',
//                 fontWeight: 600,
//                 marginTop: '16px',
//                 '&:hover': { background: '#1E88E5' },
//               }}
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={24} /> : 'Verify OTP'}
//             </Button>
//           </form>
//         </Box>
//       </StyledPaper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }
// import React, { useState } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Paper,
// } from '@mui/material';
// import { useNavigate } from 'react-router-dom';
// import OtpImage from '../landpageimage/logo1.png'; // Adjust path to your image

// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// function OtpVerification() {
//   const navigate = useNavigate();
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     if (otp.some((digit) => digit === '')) {
//       setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP', severity: 'error' });
//       return;
//     }
//     setLoading(true);

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/verify-otp/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otp: otp.join('') }),
//       });
//       const data = await response.json();
//       if (response.ok) {
//         setSnackbar({ open: true, message: 'OTP verified successfully!', severity: 'success' });
//         setTimeout(() => navigate('/dashboard'), 2000);
//       } else {
//         setSnackbar({ open: true, message: data.msg || 'Invalid OTP. Please try again.', severity: 'error' });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <Paper
//         sx={{
//           display: 'flex',
//           width: '90%',
//           maxWidth: '900px',
//           margin: '0 auto',
//           borderRadius: '24px',
//           padding: '16px',
//           overflow: 'hidden',
//           boxShadow: '0 20px 40px rgba(0, 77, 167, 0.15)',
//         }}
//       >
//         <Box
//           flex={1}
//           sx={{
//             backgroundImage: `url(${OtpImage})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             borderRadius: '24px 0 0 24px',
//             '@media (max-width: 600px)': {
//               display: 'none',
//             },
//           }}
//         />
//         <Box
//           flex={1}
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           padding="32px"
//         >
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             mb={3}
//             sx={{
//               color: 'transparent',
//               backgroundImage: themeColors.gradient,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               textAlign: 'center',
//               fontSize: '1.5rem',
//             }}
//           >
//             Verify OTP
//           </Typography>
//           <Typography mb={2} color="text.secondary">
//             Enter the 4-digit OTP sent to your registered email.
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Box display="flex" justifyContent="center">
//               {otp.map((digit, index) => (
//                 <TextField
//                   key={index}
//                   id={`otp-input-${index}`}
//                   type="text"
//                   value={digit}
//                   inputProps={{ maxLength: 1 }}
//                   onChange={(e) => handleChange(e.target, index)}
//                   sx={{
//                     width: '60px',
//                     margin: '0 8px',
//                     textAlign: 'center',
//                     fontSize: '1.5rem',
//                     borderRadius: '8px',
//                   }}
//                 />
//               ))}
//             </Box>
//             <Button
//               type="submit"
//               sx={{
//                 background: themeColors.gradient,
//                 color: 'white',
//                 padding: '8px 16px',
//                 borderRadius: '16px',
//                 fontWeight: 600,
//                 marginTop: '16px',
//                 '&:hover': { background: '#1E88E5' },
//               }}
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={24} /> : 'Verify OTP'}
//             </Button>
//           </form>
//         </Box>
//       </Paper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// export default OtpVerification;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Paper,
// } from '@mui/material';
// import { useNavigate, useLocation } from 'react-router-dom';
// import OtpImage from '../landpageimage/logo1.png'; // Adjust path to your image
// import Swal from 'sweetalert2';


// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// function OtpVerification() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const email = location.state?.email || ''; // Retrieve email dynamically if needed
//   const role = 'Student'; // Role is fixed as 'Student'
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   // Autofocus on the first input when the component loads
//   useEffect(() => {
//     document.getElementById('otp-input-0')?.focus();
//   }, []);

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };

//   // const handleSubmit = async (e) => {
//   //   e.preventDefault();

//   //   if (otp.some((digit) => digit === '')) {
//   //     setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP.', severity: 'error' });
//   //     return;
//   //   }

//   //   setLoading(true);

//   //   try {
//   //     const response = await fetch('https://newbackend.elephant-tank.com/api/verify-otp/', {
//   //       method: 'POST',
//   //       headers: { 'Content-Type': 'application/json' },
//   //       body: JSON.stringify({ otp: otp.join(''), email, role }),
//   //     });

//   //     const data = await response.json();

//   //     if (response.ok) {
//   //       setSnackbar({ open: true, message: 'OTP verified successfully!', severity: 'success' });
//   //       setTimeout(() => navigate('/'), 2000);
//   //     } else {
//   //       setSnackbar({
//   //         open: true,
//   //         message: data.msg || 'Invalid OTP. Please try again.',
//   //         severity: 'error',
//   //       });
//   //     }
//   //   } catch (error) {
//   //     setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//   //   } finally {
//   //     setLoading(false);
//   //   }
//   // };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
  
//     if (otp.some((digit) => digit === '')) {
//       setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP.', severity: 'error' });
//       return;
//     }
  
//     setLoading(true);
  
//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/verify-otp/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otp: otp.join(''), email, role }),
//       });
  
//       const data = await response.json();
  
//       if (response.ok) {
//         // Show SweetAlert success message
//         Swal.fire({
//           icon: 'success',
//           title: 'OTP Verified!',
//           text: 'You have successfully registered.',
//           confirmButtonText: 'Go to Dashboard',
//           background: '#f9f9f9',
//           customClass: {
//             confirmButton: 'swal-button',
//           },
//         }).then(() => navigate('/')); // Navigate after SweetAlert confirmation
//       } else {
//         setSnackbar({
//           open: true,
//           message: data.msg || 'Invalid OTP. Please try again.',
//           severity: 'error',
//         });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };
  
//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//       }}
//     >
//       <Paper
//         sx={{
//           display: 'flex',
//           width: '90%',
//           maxWidth: '900px',
//           margin: '0 auto',
//           borderRadius: '24px',
//           padding: '16px',
//           overflow: 'hidden',
//           boxShadow: '0 20px 40px rgba(0, 77, 167, 0.15)',
//         }}
//       >
//         <Box
//           flex={1}
//           sx={{
//             backgroundImage: `url(${OtpImage})`,
//             backgroundSize: 'cover',
//             backgroundPosition: 'center',
//             borderRadius: '24px 0 0 24px',
//             '@media (max-width: 500px)': {
//               display: 'none',
//             },
//           }}
//         />
//         <Box
//           flex={1}
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           padding="32px"
//         >
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             mb={3}
//             sx={{
//               color: 'transparent',
//               backgroundImage: themeColors.gradient,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               textAlign: 'center',
//               fontSize: '1.5rem',
//             }}
//           >
//             Verify OTP
//           </Typography>
//           <Typography mb={2} color="text.secondary" textAlign="center">
//             Enter the 4-digit OTP sent to <strong>{email || 'your email'}</strong>.
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Box display="flex" justifyContent="center" mb={3}>
//               {otp.map((digit, index) => (
//                 <TextField
//                   key={index}
//                   id={`otp-input-${index}`}
//                   type="text"
//                   value={digit}
//                   inputProps={{ maxLength: 1 }}
//                   onChange={(e) => handleChange(e.target, index)}
//                   sx={{
//                     width: '60px',
//                     margin: '0 8px',
//                     textAlign: 'center',
//                     fontSize: '1.5rem',
//                     borderRadius: '8px',
//                   }}
//                 />
//               ))}
//             </Box>
//             <Button
//               type="submit"
//               fullWidth
//               sx={{
//                 background: themeColors.gradient,
//                 color: 'white',
//                 padding: '8px 16px',
//                 borderRadius: '16px',
//                 fontWeight: 600,
//                 '&:hover': { background: '#1E88E5' },
//               }}
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
//             </Button>
//           </form>
//         </Box>
//       </Paper>
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// export default OtpVerification;

// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   Button,
//   Typography,
//   TextField,
//   Snackbar,
//   Alert,
//   CircularProgress,
//   Paper,
// } from '@mui/material';
// import { useNavigate, useLocation } from 'react-router-dom';
// import Swal from 'sweetalert2';

// // Replace these paths with your actual image paths
// import OtpImage1 from '../../src/landpageimage/logo1.png';
// import OtpImage2 from '../../src/landpageimage/TDTLLogo.png';
// import OtpImage3 from '../../src/landpageimage/logo2.jpg';
// import OtpImage4 from '../../src/landpageimage/logo1.png';


// const themeColors = {
//   primary: '#2196F3',
//   gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
//   background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
// };

// function OtpVerification() {
//   const navigate = useNavigate();
//   const location = useLocation();
//   const email = location.state?.email || ''; // Retrieve email dynamically if needed
//   const role = 'Student'; // Role is fixed as 'Student'
//   const [otp, setOtp] = useState(new Array(4).fill(''));
//   const [loading, setLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

//   useEffect(() => {
//     document.getElementById('otp-input-0')?.focus();
//   }, []);

//   const handleChange = (element, index) => {
//     if (/^\d$/.test(element.value) || element.value === '') {
//       const newOtp = [...otp];
//       newOtp[index] = element.value;
//       setOtp(newOtp);

//       if (element.value && index < 3) {
//         document.getElementById(`otp-input-${index + 1}`).focus();
//       }
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (otp.some((digit) => digit === '')) {
//       setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP.', severity: 'error' });
//       return;
//     }

//     setLoading(true);

//     try {
//       const response = await fetch('https://newbackend.elephant-tank.com/api/verify-otp/', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ otp: otp.join(''), email, role }),
//       });

//       const data = await response.json();

//       if (response.ok) {
//         Swal.fire({
//           icon: 'success',
//           title: 'OTP Verified!',
//           text: 'You have successfully registered.',
//           confirmButtonText: 'Go to Dashboard',
//           background: '#f9f9f9',
//           customClass: {
//             confirmButton: 'swal-button',
//           },
//         }).then(() => navigate('/')); // Navigate after SweetAlert confirmation
//       } else {
//         setSnackbar({
//           open: true,
//           message: data.msg || 'Invalid OTP. Please try again.',
//           severity: 'error',
//         });
//       }
//     } catch (error) {
//       setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <Box
//       sx={{
//         minHeight: '100vh',
//         display: 'flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: themeColors.background,
//         padding: '16px',
//         flexDirection: 'column',
//       }}
//     >
//       {/* Top Images */}
//       <Box
//         display="flex"
//         justifyContent="center"
//         gap={2}
//         mb={2}
//         flexWrap="wrap"
//         sx={{
//           '& img': {
//             maxWidth: '100px',
//             height: 'auto',
//             borderRadius: '12px',
//           },
//         }}
//       >
//         <img src={OtpImage1} alt="Image 1" />
//         <img src={OtpImage2} alt="Image 2" />
//         <img src={OtpImage3} alt="Image 3" />
//         <img src={OtpImage4} alt="Image 4" />
//       </Box>

//       {/* OTP Form */}
//       <Paper
//         sx={{
//           display: 'flex',
//           width: '90%',
//           maxWidth: '900px',
//           margin: '0 auto',
//           borderRadius: '24px',
//           padding: '16px',
//           overflow: 'hidden',
//           boxShadow: '0 20px 40px rgba(0, 77, 167, 0.15)',
//         }}
//       >
//         <Box
//           flex={1}
//           display="flex"
//           flexDirection="column"
//           alignItems="center"
//           justifyContent="center"
//           padding="32px"
//         >
//           <Typography
//             variant="h5"
//             fontWeight="bold"
//             mb={3}
//             sx={{
//               color: 'transparent',
//               backgroundImage: themeColors.gradient,
//               backgroundClip: 'text',
//               WebkitBackgroundClip: 'text',
//               textAlign: 'center',
//               fontSize: '1.5rem',
//             }}
//           >
//             Verify OTP
//           </Typography>
//           <Typography mb={2} color="text.secondary" textAlign="center">
//             Enter the 4-digit OTP sent to <strong>{email || 'your email'}</strong>.
//           </Typography>
//           <form onSubmit={handleSubmit}>
//             <Box display="flex" justifyContent="center" mb={3}>
//               {otp.map((digit, index) => (
//                 <TextField
//                   key={index}
//                   id={`otp-input-${index}`}
//                   type="text"
//                   value={digit}
//                   inputProps={{ maxLength: 1 }}
//                   onChange={(e) => handleChange(e.target, index)}
//                   sx={{
//                     width: '60px',
//                     margin: '0 8px',
//                     textAlign: 'center',
//                     fontSize: '1.5rem',
//                     borderRadius: '8px',
//                   }}
//                 />
//               ))}
//             </Box>
//             <Button
//               type="submit"
//               fullWidth
//               sx={{
//                 background: themeColors.gradient,
//                 color: 'white',
//                 padding: '8px 16px',
//                 borderRadius: '16px',
//                 fontWeight: 600,
//                 '&:hover': { background: '#1E88E5' },
//               }}
//               disabled={loading}
//             >
//               {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
//             </Button>
//           </form>
//         </Box>
//       </Paper>

//       {/* Snackbar */}
//       <Snackbar
//         open={snackbar.open}
//         autoHideDuration={6000}
//         onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//       >
//         <Alert
//           onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
//           severity={snackbar.severity}
//           sx={{ width: '100%' }}
//         >
//           {snackbar.message}
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// }

// export default OtpVerification;


import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  Typography,
  TextField,
  Snackbar,
  Alert,
  CircularProgress,
  Paper,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import Swal from 'sweetalert2';

// Replace these paths with your actual image paths
import OtpImage1 from '../../src/landpageimage/logo1.png';
import OtpImage2 from '../../src/landpageimage/TDTLLogo.png';
import OtpImage3 from '../../src/landpageimage/logo2.jpg';
import OtpImage4 from '../landpageimage1/DYPLogo.png';

const themeColors = {
  primary: '#2196F3',
  gradient: 'linear-gradient(135deg, #2196F3 0%, #6633EE 100%)',
  background: 'radial-gradient(217.23% 100.08% at 50% 18.33%, rgba(0, 0, 0, 0) 21.67%, #6633EE 69.34%, rgb(15, 19, 26) 100%)',
};

function OtpVerificationinves() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email || ''; // Retrieve email dynamically if needed
  const role = 'Investor'; // Role is fixed as 'Investor'
  const [otp, setOtp] = useState(new Array(4).fill(''));
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'success' });

  useEffect(() => {
    document.getElementById('otp-input-0')?.focus();
  }, []);

  const handleChange = (element, index) => {
    if (/^\d$/.test(element.value) || element.value === '') {
      const newOtp = [...otp];
      newOtp[index] = element.value;
      setOtp(newOtp);

      if (element.value && index < 3) {
        document.getElementById(`otp-input-${index + 1}`).focus();
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (otp.some((digit) => digit === '')) {
      setSnackbar({ open: true, message: 'Please enter all 4 digits of the OTP.', severity: 'error' });
      return;
    }

    setLoading(true);

    try {
      const response = await fetch('https://newbackend.elephant-tank.com/api/verify-otp/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ otp: otp.join(''), email, role }),
      });

      const data = await response.json();

      if (response.ok) {
        Swal.fire({
          icon: 'success',
          title: 'OTP Verified!',
          text: 'You have successfully registered. Login access and the link will be sent to your email. Further updates will also be communicated via email.',
          confirmButtonText: 'Okay',
          background: '#f9f9f9',
          customClass: {
            confirmButton: 'swal-button',
          },
        }).then(() => navigate('/')); 
      } else {
        setSnackbar({
          open: true,
          message: data.msg || 'Invalid OTP. Please try again.',
          severity: 'error',
        });
      }
    } catch (error) {
      setSnackbar({ open: true, message: 'An error occurred. Please try again.', severity: 'error' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: themeColors.background,
        padding: '16px',
        flexDirection: 'column',
      }}
    >
      {/* Top Images */}
      <Box
        display="flex"
        justifyContent="center"
        gap={2}
        mb={2}
        flexWrap="wrap"
        sx={{
          '& img': {
            maxWidth: '100px',
            height: 'auto',
            borderRadius: '12px',
          },
        }}
      >
        <img src={OtpImage1} alt="Image 1" />
        <img src={OtpImage2} alt="Image 2" />
        <img src={OtpImage3} alt="Image 3" />
        <img src={OtpImage4} alt="Image 4" />
      </Box>

      {/* OTP Form */}
      <Paper
        sx={{
          display: 'flex',
          width: '90%',
          maxWidth: '900px',
          margin: '0 auto',
          borderRadius: '24px',
          padding: '16px',
          overflow: 'hidden',
          boxShadow: '0 20px 40px rgba(0, 77, 167, 0.15)',
        }}
      >
        <Box
          flex={1}
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          padding="32px"
        >
          <Typography
            variant="h5"
            fontWeight="bold"
            mb={3}
            sx={{
              color: 'transparent',
              backgroundImage: themeColors.gradient,
              backgroundClip: 'text',
              WebkitBackgroundClip: 'text',
              textAlign: 'center',
              fontSize: '1.5rem',
            }}
          >
            Verify OTP
          </Typography>
          <Typography mb={2} color="text.secondary" textAlign="center">
            Enter the 4-digit OTP sent to <strong>{email || 'your email'}</strong>.
          </Typography>
          <form onSubmit={handleSubmit}>
            <Box
              display="flex"
              justifyContent="center"
              mb={3}
              gap={2}
              sx={{
                width: '100%',
                maxWidth: '400px',
                flexWrap: 'wrap',
                '& .MuiTextField-root': {
                  width: '60px',
                  height: '60px',
                  fontSize: '1.5rem',
                  textAlign: 'center',
                  borderRadius: '8px',
                  '@media (max-width: 600px)': {
                    width: '48px',
                    height: '48px',
                    fontSize: '1rem',
                  },
                  '@media (max-width: 400px)': {
                    width: '40px',
                    height: '40px',
                    fontSize: '0.9rem',
                  },
                },
              }}
            >
              {otp.map((digit, index) => (
                <TextField
                  key={index}
                  id={`otp-input-${index}`}
                  type="text"
                  value={digit}
                  inputProps={{ maxLength: 1 }}
                  onChange={(e) => handleChange(e.target, index)}
                />
              ))}
            </Box>
            <Button
              type="submit"
              fullWidth
              sx={{
                background: themeColors.gradient,
                color: 'white',
                padding: '8px 16px',
                borderRadius: '16px',
                fontWeight: 600,
                '&:hover': { background: '#1E88E5' },
              }}
              disabled={loading}
            >
              {loading ? <CircularProgress size={24} color="inherit" /> : 'Verify OTP'}
            </Button>
          </form>
        </Box>
      </Paper>

      {/* Snackbar */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={6000}
        onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setSnackbar((prev) => ({ ...prev, open: false }))}
          severity={snackbar.severity}
          sx={{ width: '100%' }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Box>
  );
}

export default OtpVerificationinves;
